export const MESSAGES = {
  VALID_NAME : 'Organization Name is required',
  VALID_DOMAINS: 'Please enter a valid format for domain(s)',
};
